const TURNSTILE_SCRIPT_ID = "turnstile-script";

export const loadTurnstile = () => {
  if (typeof window === "undefined") return Promise.reject(new Error("No window"));
  if (window.turnstile) return Promise.resolve(window.turnstile);

  return new Promise((resolve, reject) => {
    const existing = document.getElementById(TURNSTILE_SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.turnstile));
      existing.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.id = TURNSTILE_SCRIPT_ID;
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.turnstile);
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

export const renderTurnstile = ({ siteKey, container, onVerify, onExpire }) => {
  if (!siteKey || !container) return null;
  return window.turnstile.render(container, {
    sitekey: siteKey,
    callback: onVerify,
    "expired-callback": onExpire,
  });
};
